import { RootState } from '@reducers';

export const selectCancerClaim = (state: RootState) => state.userDashboardRouteReducer.claimDetails.cancerClaimDetails;
